import { render } from "./DropDownSubMenu.vue?vue&type=template&id=669bfa1b"
import script from "./DropDownSubMenu.vue?vue&type=script&lang=js"
export * from "./DropDownSubMenu.vue?vue&type=script&lang=js"

import "./DropDownSubMenu.vue?vue&type=style&index=0&id=669bfa1b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__